import React from "react";
import { useNavigate } from "react-router-dom";

export default function DashboardNotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="max-w-xl rounded-[2rem] border border-white/70 bg-white/85 p-8 text-center shadow-sm dark:border-slate-800 dark:bg-slate-900/85">
        <p className="text-sm font-bold uppercase tracking-[0.24em] text-[#4CA82F]">
          MonAppliClub
        </p>

        <h1 className="mt-3 text-3xl font-black text-slate-950 dark:text-white">
          Page introuvable
        </h1>

        <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
          Cette page du dashboard n’existe pas encore ou l’adresse est
          incorrecte.
        </p>

        <button
          type="button"
          onClick={() => navigate("/dashboard/accueil")}
          className="mt-6 rounded-2xl bg-gradient-to-r from-[#013E8E] to-[#4CA82F] px-5 py-3 text-sm font-black text-white shadow transition hover:opacity-95"
        >
          Retour au dashboard
        </button>
      </div>
    </div>
  );
}